import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sentenceCase',
})
export class SentenceCasePipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string {
    if (typeof value === 'string') {
      return sentenceCase(value);
    }

   throw new Error(`Argument is not a string`);
  }
}

export const sentenceCase = (value: string): string => {
  const result = value.toString().replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result?.slice(1);
};
